import React, {useReducer} from 'react'
import {makeStyles, TableCell, TableRow} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import moment from 'moment';
import {OfferStatusLabel} from "constants/OfferStatus";
import {OfferEncryptionStatuses, OfferEncryptionStatusLabel} from "constants/OfferEncryptionStatus";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import DateFormats from "constants/DateFormats";
import WorkableIconPreviewButton from "components/button/WorkableIconPreviewButton";
import TooltipIcon from "components/icon/TooltipIcon";
import WorkableIconEditButton from "components/button/WorkableIconEditButton";
import WorkableIconExpandButton from "components/button/WorkableIconExpandButton";
import iconWorksReducer from "libs/iconWorksReducer";
import RfxOfferService from "services/RfxOfferService";
import OfferAdditionalOffersTable from "./OfferAdditionalOffersTable";
import {getUserFullNameWithEmailAndDeputy} from "libs/userNameGetter";
import RouterPath from "../../../../libs/RouterPath";
import {StageSectionsUrlParams} from "../../../../pages/contractor/demand/scenes/offer/constants/StageSections";
import {RoundType} from "constants/RoundType";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";

const useStyles = makeStyles(theme => ({
    root: {},
    cell: {
        padding: theme.spacing(1)
    },
    buttonColumn: theme.components.table.buttonColumn,
    versionsCell: {
        background: theme.palette.background.default,
        paddingLeft: 0,
        paddingRight: 0
    },
    warnIcon: {
        padding: 0,
        color: `${theme.palette.secondary.main} !important`
    }
}));

function OfferTableRow(
    {
        demandId,
        currentRfxRound,
        index,
        offer,
        openEnvelopeEdit,
        collectionFinished,
        demandHeader
    }) {
    const classes = useStyles();
    const [iconWorks, dispatchIconWorks] = useReducer(iconWorksReducer, {
        anyWorks: false,
        addLoading: false
    });
    const {
        id, contractorName, offerUser, contractorAddress, contractorDepartmentId, encryptionStatus, status, offerDate, envelopeId, dateOfEnvelopeReceipt,
        offerDetailsUrl, hasAdditionalRounds, additionalOffers, consorciumOffer, outOfDateOffer, contractorDataAnonymized
    } = offer;
    let encIcon = encryptionStatus ? (encryptionStatus === OfferEncryptionStatuses.DECRYPTED ? LockOpenOutlinedIcon : LockOutlinedIcon) : InsertDriveFileOutlinedIcon;

    const dateStr = offerDate ? moment(offerDate).format(DateFormats.DATETIME_FORMAT) : (dateOfEnvelopeReceipt ? moment(dateOfEnvelopeReceipt).format(DateFormats.DATETIME_FORMAT) : '');

    const onAdditionalOffersExpand = () => {
        dispatchIconWorks({type: 'addLoading', works: true});

        let func;
        if (!additionalOffers) {
            func = RfxOfferService.getAdditionalRoundsOffers;
        } else {
            func = RfxOfferService.clearAdditionalRoundsOffers;
        }

        func(currentRfxRound.id, id).finally(() => {
            dispatchIconWorks({type: 'addLoading', works: false});
        })


    }

    const redirectToOffer = (roundType, offerDate) => {
        if (demandHeader && !demandHeader.apiOffers) {
            window.location.href = offerDetailsUrl;
        } else {

            let section;
            switch (roundType) {
                case RoundType.BASE:
                    section = offerDate ? StageSectionsUrlParams.OFFER_PLACED : StageSectionsUrlParams.OFFER_EDIT;
                    break;
                case RoundType.ADDITIONAL_OFFERS:
                    section = offerDate ? StageSectionsUrlParams.ADDITIONAL_OFFER_PLACED : StageSectionsUrlParams.ADDITIONAL_OFFER_EDIT;
                    break;
                case RoundType.AUCTION:
                    section = StageSectionsUrlParams.AUCTION_OFFER_PLACED;
                    break;
                default:
                    console.error("Unknown type: " + roundType);
                    section = StageSectionsUrlParams.OFFER_PLACED;
            }

            RouterPath.redirect(RouterPath.createPath(RouterPath.purchaserDemand.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE_ID_SECTION,
                {id: demandId, contractorDepartmentId, stageId: currentRfxRound.stageId, section}));
        }
    }


    return (<>
        <TableRow>
            <TableCell className={classes.cell}>{index + 1}</TableCell>
            <TableCell className={classes.cell}>{contractorDataAnonymized ? '-' : consorciumOffer ? Tr('consorcium_with_name', {name: contractorName}) : contractorName}</TableCell>
            <TableCell className={classes.cell}>{contractorDataAnonymized ? '-' : getUserFullNameWithEmailAndDeputy(offerUser)}</TableCell>
            <TableCell className={classes.cell}>{contractorDataAnonymized ? '-' : contractorAddress}</TableCell>
            <TableCell className={classes.cell}>
                <TooltipIcon tooltip={OfferEncryptionStatusLabel(encryptionStatus)} Icon={encIcon}/> {status ? OfferStatusLabel(status) : ''}
                {outOfDateOffer && <TooltipIcon iconClasses={classes.warnIcon} Icon={WarningRoundedIcon} tooltip={Tr('offerOutOfDate_warning')}/>}
            </TableCell>
            <TableCell className={classes.cell}> {dateStr}{!!envelopeId && <WorkableIconEditButton onClick={() => openEnvelopeEdit(envelopeId)}/>}</TableCell>
            <TableCell className={classes.buttonColumn}>
                <WorkableIconPreviewButton
                    tooltip={Tr('offer_details')}
                    disabled={!offerDetailsUrl}
                    onClick={offerDetailsUrl ? () => redirectToOffer(RoundType.BASE, offerDate) : undefined}
                />
            </TableCell>
            {collectionFinished && <TableCell className={classes.buttonColumn}>
                <WorkableIconExpandButton
                    tooltip={hasAdditionalRounds ? !additionalOffers ? Tr('expand_additional_offers') : Tr('collapse_additional_offers') : Tr('supplier_has_no_additional_offers')}
                    expanded={!!additionalOffers}
                    onClick={onAdditionalOffersExpand}
                    disabled={!hasAdditionalRounds || iconWorks.anyWorks}
                    working={iconWorks.addLoading}
                />
            </TableCell>}
        </TableRow>
        {!!additionalOffers &&
            <TableRow>
                <TableCell className={classes.versionsCell}></TableCell>
                <TableCell colSpan={6} className={classes.versionsCell}>
                    <OfferAdditionalOffersTable
                        additionalOffers={additionalOffers}
                        redirectToOffer={redirectToOffer}
                    />
                </TableCell>
                <TableCell className={classes.versionsCell}></TableCell>
            </TableRow>
        }
    </>)
}

OfferTableRow.propTypes = {
    index: PropTypes.number.isRequired,
    offer: PropTypes.object.isRequired,
    openEnvelopeEdit: PropTypes.func.isRequired,
    collectionFinished: PropTypes.bool.isRequired,
}

export default OfferTableRow;
